module.exports = __webpack_public_path__ + "static/media/cosmosbanner_sm2.589a459c.png";